import React from 'react';

function Resources() {
  return (
    <div className="tab-content">
      <h2>Resources</h2>

      <div style={{ marginBottom: '30px' }}>
        <p style={{ fontSize: '16px', lineHeight: '1.8', marginBottom: '15px' }}>
          Access our comprehensive collection of resources designed to help students,
          researchers, and service providers navigate the research process ethically and effectively.
        </p>
      </div>

      <div style={{ marginBottom: '40px' }}>
        <h3 style={{ color: '#2c3e50', borderBottom: '2px solid #3498db', paddingBottom: '10px', marginBottom: '20px' }}>
          Research Guides & Best Practices
        </h3>
        <div style={{ display: 'grid', gap: '15px' }}>
          <div style={{ padding: '15px', backgroundColor: '#ecf0f1', borderRadius: '8px', borderLeft: '4px solid #27ae60' }}>
            <h4 style={{ color: '#27ae60', marginBottom: '8px' }}>📘 How to Choose a Research Topic</h4>
            <p style={{ fontSize: '14px', lineHeight: '1.6', color: '#555' }}>
              Step-by-step guide for selecting an impactful and feasible research topic
            </p>
          </div>

          <div style={{ padding: '15px', backgroundColor: '#ecf0f1', borderRadius: '8px', borderLeft: '4px solid #2980b9' }}>
            <h4 style={{ color: '#2980b9', marginBottom: '8px' }}>📝 Research Methodology Guide</h4>
            <p style={{ fontSize: '14px', lineHeight: '1.6', color: '#555' }}>
              Comprehensive guide on qualitative and quantitative research methods
            </p>
          </div>

          <div style={{ padding: '15px', backgroundColor: '#ecf0f1', borderRadius: '8px', borderLeft: '4px solid #e74c3c' }}>
            <h4 style={{ color: '#e74c3c', marginBottom: '8px' }}>✓ Plagiarism Prevention Guide</h4>
            <p style={{ fontSize: '14px', lineHeight: '1.6', color: '#555' }}>
              Learn proper citation, paraphrasing, and how to maintain originality
            </p>
          </div>

          <div style={{ padding: '15px', backgroundColor: '#ecf0f1', borderRadius: '8px', borderLeft: '4px solid #f39c12' }}>
            <h4 style={{ color: '#f39c12', marginBottom: '8px' }}>📊 Data Analysis Basics</h4>
            <p style={{ fontSize: '14px', lineHeight: '1.6', color: '#555' }}>
              Introduction to statistical analysis and data interpretation
            </p>
          </div>
        </div>
      </div>

      <div style={{ marginBottom: '40px' }}>
        <h3 style={{ color: '#2c3e50', borderBottom: '2px solid #3498db', paddingBottom: '10px', marginBottom: '20px' }}>
          Plagiarism Check Support
        </h3>
        <div style={{ padding: '20px', backgroundColor: '#e8f8f5', borderRadius: '8px', border: '1px solid #27ae60' }}>
          <h4 style={{ color: '#27ae60', marginBottom: '15px' }}>Free Plagiarism Checking Resources</h4>
          <ul style={{ fontSize: '15px', lineHeight: '2', paddingLeft: '20px' }}>
            <li style={{ marginBottom: '8px' }}>
              <strong>Recommended Tools:</strong> Turnitin, Grammarly, Copyscape, Quetext
            </li>
            <li style={{ marginBottom: '8px' }}>
              <strong>Best Practices:</strong> Check your work before submission, maintain proper citations
            </li>
            <li style={{ marginBottom: '8px' }}>
              <strong>Acceptable Similarity:</strong> Generally below 15-20% depending on your institution
            </li>
            <li style={{ marginBottom: '8px' }}>
              <strong>Support:</strong> Contact our legal desk for plagiarism dispute resolution
            </li>
          </ul>
        </div>
      </div>

      <div style={{ marginBottom: '40px' }}>
        <h3 style={{ color: '#2c3e50', borderBottom: '2px solid #3498db', paddingBottom: '10px', marginBottom: '20px' }}>
          Legal Assistance & Consumer Protection
        </h3>
        <div style={{ padding: '20px', backgroundColor: '#fef5e7', borderRadius: '8px', border: '1px solid #f39c12' }}>
          <h4 style={{ color: '#f39c12', marginBottom: '15px' }}>Know Your Rights</h4>
          <div style={{ fontSize: '15px', lineHeight: '1.8' }}>
            <p style={{ marginBottom: '12px' }}>
              <strong>For Students & Customers:</strong>
            </p>
            <ul style={{ paddingLeft: '20px', marginBottom: '20px' }}>
              <li style={{ marginBottom: '8px' }}>Right to original and plagiarism-free work</li>
              <li style={{ marginBottom: '8px' }}>Right to refund as per agreed terms</li>
              <li style={{ marginBottom: '8px' }}>Right to legal assistance in case of fraud</li>
              <li style={{ marginBottom: '8px' }}>Right to report unethical practices</li>
            </ul>

            <p style={{ marginBottom: '12px' }}>
              <strong>For Service Providers:</strong>
            </p>
            <ul style={{ paddingLeft: '20px' }}>
              <li style={{ marginBottom: '8px' }}>Protection against false complaints</li>
              <li style={{ marginBottom: '8px' }}>Legal support in disputes</li>
              <li style={{ marginBottom: '8px' }}>Contract templates and guidance</li>
              <li style={{ marginBottom: '8px' }}>Fair hearing and representation</li>
            </ul>
          </div>
        </div>
      </div>

      <div style={{ marginBottom: '40px' }}>
        <h3 style={{ color: '#2c3e50', borderBottom: '2px solid #3498db', paddingBottom: '10px', marginBottom: '20px' }}>
          Research Ethics Guidelines
        </h3>
        <div style={{ padding: '20px', backgroundColor: '#ebf5fb', borderRadius: '8px' }}>
          <ul style={{ fontSize: '15px', lineHeight: '2', paddingLeft: '20px' }}>
            <li style={{ marginBottom: '10px' }}>
              <strong>Originality:</strong> All research must be original and properly cited
            </li>
            <li style={{ marginBottom: '10px' }}>
              <strong>Informed Consent:</strong> Obtain proper consent from research participants
            </li>
            <li style={{ marginBottom: '10px' }}>
              <strong>Data Integrity:</strong> Never fabricate or manipulate research data
            </li>
            <li style={{ marginBottom: '10px' }}>
              <strong>Confidentiality:</strong> Protect the privacy of research subjects
            </li>
            <li style={{ marginBottom: '10px' }}>
              <strong>Transparency:</strong> Disclose funding sources and potential conflicts of interest
            </li>
          </ul>
        </div>
      </div>

      <div style={{
        backgroundColor: '#3498db',
        color: 'white',
        padding: '25px',
        borderRadius: '10px',
        textAlign: 'center'
      }}>
        <h3 style={{ marginBottom: '12px' }}>Need Additional Support?</h3>
        <p style={{ fontSize: '16px', lineHeight: '1.6' }}>
          Visit our Contact page for personalized assistance with your research queries,
          legal matters, or to request specific resources not listed here.
        </p>
      </div>
    </div>
  );
}

export default Resources;
